import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import api from '../utils/api';
import { buildPublicOfferCopy, validatePublicOffer } from '../utils/publicOffer';

const PublicOfferContext = createContext(null);

export function PublicOfferProvider({ initialOffer = null, children }) {
  const [offer, setOffer] = useState(() => validatePublicOffer(initialOffer));
  useEffect(() => {
    let active = true;
    api.getPublicOffer().then((response) => {
      const next = validatePublicOffer(response);
      if (active && next) setOffer(next);
    }).catch(() => {}); // Keep the valid prerender snapshot on transport failure.
    return () => { active = false; };
  }, []);
  const value = useMemo(() => ({ offer, ...buildPublicOfferCopy(offer) }), [offer]);
  return <PublicOfferContext.Provider value={value}>{children}</PublicOfferContext.Provider>;
}

export function usePublicOffer() {
  const value = useContext(PublicOfferContext);
  return value || { offer: null, ...buildPublicOfferCopy(null) };
}
